"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_axis_grid_stroke_Color_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_axis_grid_stroke_Color"));
const chart_axis_tick_stroke_Color_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_axis_tick_stroke_Color"));
// Axis theme
exports.AxisTheme = {
    axis: {
        style: {
            grid: {
                stroke: chart_axis_grid_stroke_Color_1.default.value
            },
            ticks: {
                stroke: chart_axis_tick_stroke_Color_1.default.value
            }
        }
    }
};
//# sourceMappingURL=axis-theme.js.map